import { Injectable } from '@angular/core';
import { TranslateConfigService } from '../translate-config.service';
import { Subject, Observable } from 'rxjs';
import { AppStorageService } from '../app-storage.service';
import { StorageKeys } from '../storage-keys';

@Injectable({
  providedIn: 'root',
})
export class PostsService {
  constructor(private translateConfigService: TranslateConfigService, private storage: AppStorageService) {}

  categories : any[] = [
  ];

  selectedCategory: any = this.categories[0];

  inputs = [
    {
      // use translation keys as labels/placeholders and let templates translate with the pipe
      label: 'FORM_INPUTS.TITLE.LABEL',
      formControlName: 'title',
      type: 'text',
      placeholder: 'FORM_INPUTS.TITLE.PLACEHOLDER',
      required: true,
      visible: true,
    },
    {
      label: 'FORM_INPUTS.CATEGORY.LABEL',
      formControlName: 'category',
      type: 'select',
      placeholder: 'FORM_INPUTS.CATEGORY.PLACEHOLDER',
      options: [
        {
          label: 'FORM_INPUTS.CATEGORY.OPTIONS.1',
          value: 1,
        },
        {
          label: 'FORM_INPUTS.CATEGORY.OPTIONS.2',
          value: 2,
        },
      ],
      required: true,
      visible: true,
    },
    {
      label: 'FORM_INPUTS.SUBCATEGORY.LABEL',
      formControlName: 'subcategory',
      type: 'select',
      placeholder: 'FORM_INPUTS.SUBCATEGORY.PLACEHOLDER',
      options: [
        {
          label: 'FORM_INPUTS.SUBCATEGORY.OPTIONS.1',
          value: 1,
        },
        {
          label: 'FORM_INPUTS.SUBCATEGORY.OPTIONS.2',
          value: 2,
        },
      ],
      required: true,
      visible: true,
    },
    {
      label: 'FORM_INPUTS.ATTRIBUTES.LABEL',
      formControlName: 'attributes',
      type: 'multiselect',
      placeholder: 'FORM_INPUTS.ATTRIBUTES.PLACEHOLDER',
      required: false,
      // Hidden by default; create/edit pages will show it only when a subcategory is selected and attributes exist
      visible: false,
      options: []
    },
    {
      label: 'FORM_INPUTS.VALUE.LABEL',
      formControlName: 'value',
      type: 'text',
      placeholder: 'FORM_INPUTS.VALUE.PLACEHOLDER',
      required: false,
      visible: true,
    },
    {
      label: 'FORM_INPUTS.DESCRIPTION.LABEL',
      formControlName: 'description',
      type: 'textarea',
      placeholder: 'FORM_INPUTS.DESCRIPTION.PLACEHOLDER',
      required: true,
      visible: true,
    },
    {
      label: 'FORM_INPUTS.IMAGES.LABEL',
      formControlName: 'images',
      type: 'file',
      placeholder: '',
      required: false,
      visible: true,
    },
    {
      label: 'FORM_INPUTS.ADDRESS.LABEL',
      formControlName: 'address',
      type: 'map',
      placeholder: '',
      required: false,
      visible: true,
    },
  ];

  items : any[] = [
  ];

  myItems: any[] = [];

  selectedItem: any = this.items[0];

  async getCategories() {
    return this.categories;
  }

  async getSubcategories(id: number) {
    return this.categories.find((c) => c.id === id)?.subcategories || [];
  }

  async getObjs() {
    return this.items.concat(this.myItems);
  }

  async getFilterObjs(
    selectedCategory: number = 1,
    subSelectedCategory: number | null = null
  ) {
    return this.items.filter((obj) => {
      const matchCategory =
        selectedCategory === 1 || obj.category === selectedCategory;
      const subMatchCategory =
        subSelectedCategory === null ||
        subSelectedCategory === 21 ||
        obj.subcategory === subSelectedCategory;

      return matchCategory && subMatchCategory;
    });
  }

  /**
   * Traduce los campos label y placeholder de un array de inputs
   * @param inputsArray Array de inputs que se quiere traducir
   * @returns Array con los inputs traducidos
   */
  private translateInputsArray(inputsArray: any[]): any[] {
    return inputsArray.map((input) => {
      // Not used anymore: templates will use the translate pipe on input.label
      return { ...input };
    });
  }

  /**
   * Devuelve los inputs preparados (posiblemente traducidos) para el formulario
   */
  async getInputs() {
    return this.translateInputsArray(this.inputs);
  }

  async getMyItems() {
    return this.myItems;
  }

  async selectCategory(category: any) {
    this.selectedCategory = category;
  }

  async getSelectedCategory() {
    return this.selectedCategory;
  }

  async selectItem(item: any) {
    this.selectedItem = item;
    this.storage.set(StorageKeys.ARTICLE_ID, item.id.toString());
  }

  async getSelectedItem() {
    return this.selectedItem;
  }

  async getItemById(id: number) {
    return (
      this.items.find((obj) => obj.id === id) ||
      this.myItems.find((obj) => obj.id === id)
    );
  }

  async getSubCategories() {
    return (
      this.categories.find((c) => c.id === this.selectedCategory)
        ?.subcategories || []
    );
  }

  async addPost(post: any) {
    this.myItems.push(post);
  }

  private postToCreate: number = 0;

  setPostToCreate(type: number): void {
    this.postToCreate = type;
    // También guardarlo en el storage para persistencia
    this.storage.set(StorageKeys.POST_TO_CREATE, type.toString());

  }

  getPostToCreate(): number {
    // Primero intentar desde la propiedad de la clase
    if (this.postToCreate !== 0) {
      return this.postToCreate;
    }

    // Si no está en la clase, intentar desde el storage
    const stored = this.storage.get(StorageKeys.POST_TO_CREATE);
    if (stored) {
      this.postToCreate = parseInt(stored, 10);
      return this.postToCreate;
    }

    return 0; // valor por defecto
  }

  clearPostToCreate(): void {
    this.postToCreate = 0;
    this.storage.remove(StorageKeys.POST_TO_CREATE);
  }

  getPostData(id: number) {
    let post = this.myItems.find((item) => item.id === id);
    return post;
  }

  deletePost(id: number) {
    const index = this.myItems.findIndex((item) => item.id === id);
    if (index !== -1) {
      this.myItems.splice(index, 1);
    }
  }

  updatePost(id: number, newData: any) {
    const index = this.myItems.findIndex((item) => item.id === id);
    if (index !== -1) {
      this.items[index] = newData;
    }
  }

  // --- STREAMS DE ACTUALIZACIÓN LISTING/DETAILS ---
  /**
   * Subject que emite cuando el listado ha sido actualizado.
   * Se envía el array completo de artículos visibles (opcional) o sólo sus IDs.
   */
  private listingUpdatedSubject = new Subject<{ ids?: number[]; articles?: any[] }>();

  /** Observable público para que detalles (u otros) reaccionen a cambios del listing */
  listingUpdated$: Observable<{ ids?: number[]; articles?: any[] }> = this.listingUpdatedSubject.asObservable();

  /**
   * Emitir evento de actualización de listado.
   * @param articles Array de artículos actualmente mostrados (opcional para minimizar payload)
   */
  emitListingUpdated(articles: any[] = []) {
    const ids = articles.map(a => a?.id).filter((v: any) => v != null);
    this.listingUpdatedSubject.next({ ids, articles });
  }
}
